import UltMeta, { Meta } from "./UltMeta/index";

class Scope extends UltMeta {
    ALL = new Meta(1, "全部");
    SUPPLIER_CHAIN = new Meta(2, "供应链端");
    CUSTOM = new Meta(3, "客户端");
}
export const NOTICE_SCOPE = new Scope();

class Type extends UltMeta {
    SYSTEM = new Meta(1, "系统公告");
    OPERATION = new Meta(2, "运营公告");
}
export const NOTICE_TYPE = new Type();

class State extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    TO_BE_PUBLISHED = new Meta(2, "待发布");
    PUBLISHED = new Meta(3, "已发布");
    DELETE = new Meta(4, "已删除");
}
export const NOTICE_STATE = new State();
